export const Modal = ({ size = 'small', isOpen = false, children }) => {
  if (!isOpen) return
  return <div>
    <div className='control-modal-overlay' />
    <section role='dialog' tabIndex='-1' class={`control-modal control-modal-${size}`} >
      {children}
    </section>
  </div>
}
